"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdPartyMediator = void 0;
const enums_1 = require("../enums");
const IdvMediator_enums_1 = require("../IdvMediator/IdvMediator.enums");
class ThirdPartyMediator {
    constructor(props) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.listener = null;
        this.registerHandler = (listener) => {
            if (this.listener) {
                throw new Error(enums_1.ErrorType.ListenerExist);
            }
            this.listener = listener;
        };
        this.send = (data) => {
            this.communicationWindow.postMessage(data, '*');
        };
        this.unregisterHandlers = () => {
            window.removeEventListener('message', this.receiveMessage, false);
            this.listener = null;
        };
        this.receiveMessage = (event) => {
            var _a, _b;
            const { data, origin } = event;
            if ((this.allowedOrigin && this.allowedOrigin !== origin) ||
                (((_a = data === null || data === void 0 ? void 0 : data.name) === null || _a === void 0 ? void 0 : _a.endsWith) &&
                    (data.name.endsWith(IdvMediator_enums_1.ControllerType.Parent) ||
                        data.name.endsWith(IdvMediator_enums_1.ControllerType.Child)))) {
                return;
            }
            (_b = this.listener) === null || _b === void 0 ? void 0 : _b.call(this, data);
        };
        if (props) {
            const { allowedOrigin, iframeElement } = props;
            this.allowedOrigin = allowedOrigin || null;
            this.communicationWindow = (iframeElement === null || iframeElement === void 0 ? void 0 : iframeElement.contentWindow) || window.parent;
        }
        else {
            this.allowedOrigin = null;
            this.communicationWindow = window.parent;
        }
        window.addEventListener('message', this.receiveMessage, false);
    }
}
exports.ThirdPartyMediator = ThirdPartyMediator;
